import React from 'react'
import { t } from 'ttag'

import { SendTestsMessageModal } from 'components/modals/common/SendTestsMessageModal/SendTestsMessageModal'
import { JOB_TEMPLATE_MODE } from '../common/SendTestsMessageModal/common/SendTestsMessageForm/model'

export const SendTestsRemindersModal = ({
  candidates,
  deadline,
  name,
  onCancel,
  onClose,
  onConfirm,
  isOpen,
  mode = JOB_TEMPLATE_MODE,
  isExtending = false,
}) => (
  <SendTestsMessageModal
    title={t`Send reminder message`}
    subtitle={t`Reminder messages`}
    type="reminder"
    mode={mode}
    {...{
      candidates,
      deadline,
      name,
      onCancel,
      onClose,
      onConfirm,
      isOpen,
      isExtending,
    }}
  />
)
